import { css } from '@emotion/react';

export default css`
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-ExtraleichtKursiv.otf')
      format('opentype');
    font-weight: 200;
    font-style: 'italic';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-Extraleicht.otf')
      format('opentype');
    font-weight: 200;
    font-style: 'normal';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-LeichtKursiv.otf')
      format('opentype');
    font-weight: 300;
    font-style: 'italic';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-Leicht.otf')
      format('opentype');
    font-weight: 300;
    font-style: 'normal';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-BuchKursiv.otf')
      format('opentype');
    font-weight: 400;
    font-style: 'italic';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-Buch.otf')
      format('opentype');
    font-weight: 400;
    font-style: 'normal';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-Kraftig.otf')
      format('opentype');
    font-weight: 500;
    font-style: 'normal';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-Halbfett.otf')
      format('opentype');
    font-weight: 600;
    font-style: 'normal';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-DreiviertelfettKursiv.otf')
      format('opentype');
    font-weight: 700;
    font-style: 'italic';
  }
  @font-face {
    font-family: 'Sohne';
    src: url('https://sohne-font.s3.us-east-2.amazonaws.com/Sohne-Dreiviertelfett.otf')
      format('opentype');
    font-weight: 700;
    font-style: 'normal';
  }
  
  @font-face {
  font-family:'Noto Sans';
  font-style:normal;
  font-weight:400;
  src:url('/de/fonts/noto-sans-v9-latin-regular.eot');
  src:local('Noto Sans'),
  local('NotoSans'),
  url('/de/fonts/noto-sans-v9-latin-regular.eot?#iefix') format('embedded-opentype'),
  url('/de/fonts/noto-sans-v9-latin-regular.woff2') format('woff2'),
  url('/de/fonts/noto-sans-v9-latin-regular.woff') format('woff'),
  url('/de/fonts/noto-sans-v9-latin-regular.ttf') format('truetype'),
  url('/de/fonts/noto-sans-v9-latin-regular.svg#NotoSans') format('svg');
  font-display:swap
}
@font-face {
  font-family:'Noto Sans';
  font-style:italic;
  font-weight:400;
  src:url('/de/fonts/noto-sans-v9-latin-italic.eot');
  src:local('Noto Sans Italic'),
  local('NotoSans-Italic'),
  url('/de/fonts/noto-sans-v9-latin-italic.eot?#iefix') format('embedded-opentype'),
  url('/de/fonts/noto-sans-v9-latin-italic.woff2') format('woff2'),
  url('/de/fonts/noto-sans-v9-latin-italic.woff') format('woff'),
  url('/de/fonts/noto-sans-v9-latin-italic.ttf') format('truetype'),
  url('/de/fonts/noto-sans-v9-latin-italic.svg#NotoSans') format('svg');
  font-display:swap
}
@font-face {
  font-family:'Noto Sans';
  font-style:italic;
  font-weight:700;
  src:url('/de/fonts/noto-sans-v9-latin-700italic.eot');
  src:local('Noto Sans Bold Italic'),
  local('NotoSans-BoldItalic'),
  url('/de/fonts/noto-sans-v9-latin-700italic.eot?#iefix') format('embedded-opentype'),
  url('/de/fonts/noto-sans-v9-latin-700italic.woff2') format('woff2'),
  url('/de/fonts/noto-sans-v9-latin-700italic.woff') format('woff'),
  url('/de/fonts/noto-sans-v9-latin-700italic.ttf') format('truetype'),
  url('/de/fonts/noto-sans-v9-latin-700italic.svg#NotoSans') format('svg');
  font-display:swap
}
@font-face {
  font-family:'Noto Sans';
  font-style:normal;
  font-weight:700;
  src:url('/de/fonts/noto-sans-v9-latin-700.eot');
  src:local('Noto Sans Bold'),
  local('NotoSans-Bold'),
  url('/de/fonts/noto-sans-v9-latin-700.eot?#iefix') format('embedded-opentype'),
  url('/de/fonts/noto-sans-v9-latin-700.woff2') format('woff2'),
  url('/de/fonts/noto-sans-v9-latin-700.woff') format('woff'),
  url('/de/fonts/noto-sans-v9-latin-700.ttf') format('truetype'),
  url('/de/fonts/noto-sans-v9-latin-700.svg#NotoSans') format('svg');
  font-display:swap
  }

  --primary-font-family: Noto Sans, system-ui, sans-serif;
  --code-font: 'Menlo', 'Consolas', monospace;

  --paragraph-spacing: 1.25rem;
`;
